import { Component }     from '@angular/core';
import { Router }        from '@angular/router';
import { Platform, AnimationController }      from '@ionic/angular';

// Plugins
import { SplashScreen }  from '@ionic-native/splash-screen/ngx';
import { StatusBar }     from '@ionic-native/status-bar/ngx';
import { OneSignal }     from '@ionic-native/onesignal/ngx';

// Constants
import { OneSignalConstants } from './constants/onesignal';
import { EventsConstants }    from './constants/events';

// Services
import { AuthService }   from './services/auth.service';
import { EventsService } from './services/events.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

	private loadingTimeout = 500;
	public defaultPageTransition = ((baseEl: any, opts?: any) => { 
	    var leavingAnimation = this.animationCtrl.create()
	      .addElement(opts.leavingEl)
	      .duration(500)
	      .iterations(1)
	      .easing('ease-out')
	      .fromTo('opacity', '1', '0.0')
	    var enterAnimation = this.animationCtrl.create()
	      .addElement(opts.enteringEl)
	      .duration(500)
	      .iterations(1)
	      .easing('ease-out')
	      .fromTo('opacity', '0.0', '1')
	     var pageAnimation = this.animationCtrl.create()
	      .duration(500)
	      .iterations(1)
	      .addAnimation([leavingAnimation, enterAnimation]);
	    return pageAnimation;
	});

	constructor(
	  	private platform: Platform,
	  	private splashScreen: SplashScreen,
	  	private statusBar: StatusBar,
        private oneSignal: OneSignal,
	  	private authService: AuthService,
	  	private eventsService: EventsService,
    	private animationCtrl: AnimationController,
	  	private router: Router
	) {
	  this.initializeApp();
	}

  	initializeApp() {

    	this.platform.ready().then(() => {
    	    this.statusBar.styleDefault();
    	    this.splashScreen.hide();

    	    this.oneSignal.startInit(OneSignalConstants.PUBLICKEY, OneSignalConstants.APPID);
            this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);
            this.oneSignal.handleNotificationReceived().subscribe(() => {
            	this.eventsService.publish(EventsConstants.NOTIFICATION_UPDATE);
            });
            this.oneSignal.handleNotificationOpened().subscribe(() => {});
            this.oneSignal.endInit();

            this.eventsService.subscribe(EventsConstants.AUTH_CONNECTED, (params : any = {}) => { 
                let that = this;
                this.oneSignal.getIds().then((id) => {
                    that.authService.update({
                        'push_onesignal' : id.userId
                    });
                }); 
            });
    	});

    	this.router.navigate(['loading'], {replaceUrl: true});
		let that = this;
        this.authService.fetch().subscribe((res: any) => {
            this.authService.data = res.result;
            this.eventsService.publish(EventsConstants.AUTH_CONNECTED);
            setTimeout(function() {
            	that.router.navigate(['slides'], {replaceUrl: true});
            	setTimeout(function() {
            		that.defaultPageTransition = null;
            	},this.loadingTimeout);
            },this.loadingTimeout);
        },
        (err: any) => {
            setTimeout(function() {
            	that.router.navigate(['login'], {replaceUrl: true});
            	setTimeout(function() {
            		that.defaultPageTransition = null;
            	},this.loadingTimeout);
            },this.loadingTimeout);
        });

  }
}
